<template>
  <div :class="{ 'entity-border': apresentaBorda, 'mb-3': apresentaBorda }">
    <v-layout row wrap form-padding>
      <v-flex xs12>
        <span class="title" v-html="getLabel()"></span>
      </v-flex>
      <v-flex md2 sm12>
        <v-text-field
          placeholder=" "
          readonly
          class="form-input-box"
          :label="'CPF'"
          :value="formatCPF(pessoa.documento)"
        />
      </v-flex>
      <v-flex md4 sm12>
        <v-text-field
          placeholder=" "
          readonly
          class="form-input-box"
          label="Nome"
          :value="pessoa.nome"
        />
      </v-flex>
      <v-flex md4 sm12 v-if="apresentaEmail">
        <v-text-field
          placeholder=" "
          readonly
          class="form-input-box"
          label="Email"
          :value="pessoa.email"
        />
      </v-flex>

      <v-flex md2 sm12 mt-4 v-if="apresentaEmail" class="pull-right">
        <a
          href
          @click.prevent="editarEmail(pessoa)"
          class="proposta__blue-text mt-2"
        >
          <v-icon>edit</v-icon>Editar e-mail
        </a>
      </v-flex>

      <v-flex xs3 mt-4 v-if="!pessoa.conjuge && !isConjuge">
        <a
          href
          @click.prevent="addPessoa('FIADORES', pessoa)"
          class="proposta__blue-text mt-2"
        >
          <v-icon>add_circle</v-icon>Adicionar Cônjuge
        </a>
      </v-flex>
    </v-layout>
    <tomador-ccg-fiadores-fisica
      v-if="pessoa.conjuge"
      :pessoa="pessoa.conjuge"
      @click="handleClickEvent"
      @save="handleSaveEvent"
      is-conjuge
    />
  </div>
</template>

<script lang="js">
import { formatCPF } from "@/libs/utils";

export default {
  name: "TomadorCCGFiadoresFisica",
  props: {
    pessoa: {
      type: Object,
    },
    isConjuge: {
      type: Boolean,
      default: false,
    },
    isFilho: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatCPF
    };
  },
  computed: {
    apresentaEmail() {
      if (this.pessoa.tipo_pessoa == "JURIDICA") return false;
      else return true;
    },
    apresentaBorda() {
      return !this.isConjuge || this.pessoa.conjuge;
    },
  },
  methods: {
    getLabel() {
      let label = this.isConjuge
        ? "Cônjuge"
        : this.isFilho
        ? "Representante"
        : "Fiador";

      return label;
    },
    handleClickEvent(data) {
      this.$emit("click", data);
    },
    handleSaveEvent(data) {
      this.$emit("save", data);
    },
    editarEmail(pessoa) {
      const data = Object.assign(
        {},
        {
          id_pessoa: pessoa.id_pessoa,
          documento_pessoa: pessoa.documento,
          nome_pessoa: pessoa.nome,
          email_pessoa: pessoa.email,
          tipo_pessoa: pessoa.tipo_pessoa,
          categoria: "Fiador",
        }
      );
      this.$emit("save", data);
    },
    addPessoa(categoria, pai) {
      this.$emit("click", { pessoa: null, categoria: categoria, pai: pai });
    },
  },
};
</script>

<style lang="css" scoped>
.title {
  color: #282498;
  border-bottom: 1px solid #282498;
}
.entity-border {
  border: 1px solid #eee;
  padding: 16px;
}
</style>


// WEBPACK FOOTER //
// ./src/components/TomadorCCGFiadoresFisica.vue